module.exports = new __parcel__URL__("shop_machines_1st_birthday_cake.fdf4be08.png").toString();